module.exports = __webpack_public_path__ + "static/media/organization_location.ca90e300.svg";